module.exports = __webpack_public_path__ + "static/img/16.16523158.jpg";